import { SelectCategoryPage } from './select-category/page'
import { withNonAuthenticated } from '../../components/with-non-authenticated/with-non-authenticated'
import { RegisterClientPage } from './register-client/page'

export const SignUpWithOrderStack = {
  SelectCategoryPage: withNonAuthenticated(SelectCategoryPage),
  RegisterClientPage: withNonAuthenticated(RegisterClientPage),
}
